import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import PublicFooter from "@/components/PublicFooter";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Fehler beim Versand. Bitte erneut versuchen.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md bg-white rounded-2xl border border-neutral-200 shadow-sm p-8" data-testid="forgot-password-page">
          <Link to="/login" className="text-xs text-neutral-500 hover:text-neutral-900 flex items-center gap-1 mb-6">
            <ArrowLeft className="h-3 w-3" /> Zurück zum Login
          </Link>
          <div className="h-12 w-12 rounded-xl bg-emerald-500 flex items-center justify-center font-display font-bold text-neutral-900 mb-6">AC</div>

          {submitted ? (
            <div data-testid="forgot-success">
              <h1 className="font-display text-2xl font-semibold tracking-tight mb-3">E-Mail unterwegs</h1>
              <p className="text-neutral-600 mb-6">
                Falls die Adresse <strong>{email}</strong> bei uns registriert ist, haben wir dir gerade einen Link zum Zurücksetzen des Passworts geschickt. Der Link ist 24 Stunden gültig.
              </p>
              <div className="rounded-xl bg-neutral-100 p-4 text-sm text-neutral-600">
                <Mail className="h-4 w-4 inline mr-2" />
                Checke auch deinen Spam-Ordner — falls in 5 Minuten nichts da ist, melde dich unter <a href="mailto:hello@agency-cash.app" className="underline">hello@agency-cash.app</a>.
              </div>
              <Button asChild className="w-full mt-6"><Link to="/login">Zurück zum Login</Link></Button>
            </div>
          ) : (
            <>
              <h1 className="font-display text-2xl font-semibold tracking-tight mb-2">Passwort vergessen?</h1>
              <p className="text-neutral-500 mb-6">Gib deine E-Mail-Adresse ein. Wir schicken dir einen Link zum Zurücksetzen.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label htmlFor="fp-email">E-Mail</Label>
                  <Input id="fp-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" autoFocus />
                </div>
                {error && <div className="text-sm text-red-600" data-testid="forgot-error">{error}</div>}
                <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
                  {loading ? "Wird gesendet…" : "Reset-Link senden"}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
